import 'src/global.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { initUiTelemetry } from './lib/ui-telemetry';

// ----------------------------------------------------------------------

// Before render, so a crash during mount is itself captured as a breadcrumb.
initUiTelemetry();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root not found');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Safety net: the native splash is configured with launchAutoHide:false and is
// normally hidden by RootLayout once the UI paints. If React ever fails to mount,
// force-hide it after a grace period so the splash can't stay up forever. (No-op
// on web - guarded by the native-only Capacitor global.)
const capacitor = (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } })
  .Capacitor;
if (capacitor?.isNativePlatform?.()) {
  // Confirm this bundle booted so the OTA plugin doesn't roll it back. Must fire
  // within the configured readyTimeout (capacitor.config.ts) - do it as soon as
  // React has been handed the container above.
  import('src/utils/ota-updater')
    .then((m) => m.markAppReady())
    .catch(() => {});

  setTimeout(() => {
    import('src/utils/capacitor')
      .then((m) => m.hideNativeSplash())
      .catch(() => {});
  }, 10000);
}
